module.exports = __webpack_public_path__ + "static/media/officeImg2.0aaee6b2.png";